import { useEffect, useReducer, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import axios from 'axios';
import { getReducer } from '../../../../utils';
import LoadingBox from '../../../compoment/LoadingBox';
import MessageBox from '../../../compoment/MessageBox';

import '../css/culturePost.css';
import truncateWords from '../../../../format/truncateWords';
import Pagination from '../../../compoment/Pagination';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_POST':
      return { ...state, posts: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const CulturePost = ({ topicSlug }) => {
  const navigate = useNavigate();

  const [pageIndex, setPageIndex] = useState(1);
  const MAX_LIMIT = 10;

  const [{ loading, error, posts }, dispatch] = useReducer(
    getReducer(reducer),
    {
      posts: [],
      loading: true,
      error: '',
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const resultPost = await axios.get(
          `/post/public/shows?topicSlug=${topicSlug}&page=${pageIndex}&limit=${MAX_LIMIT}`
        );

        dispatch({
          type: 'FETCH_SUCCESS_POST',
          payload: resultPost.data.data,
        });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, [topicSlug, pageIndex]);

  const handleNavigative = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/tuyen-dung/co-hoi-nghe-nghiep');
  };

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <section>
      <div className="bg-white shadow-lg mb-3 culture-post px-lg-5 px-3">
        <h1 className="text-center default-box-title m-0">
          VĂN HÓA THÀNH ĐỒNG GROUP
        </h1>
        <div className="row">
          {posts.posts.length > 0 ? (
            posts.posts.map((post, index) => (
              <div key={index} className=" col-12 col-md-6  item">
                <div className=" p-md-2">
                  <div className="image-wrapper">
                    <img
                      src={post.thumbnail}
                      alt={post.title}
                      className="img-post"
                    />
                  </div>
                  <div className=" pl-4">
                    <h3 className="mt-2 mb-1">
                      <Link to={`/tuyen-dung/${post.slug}`} title={post.title}>
                        {post.title}
                      </Link>
                    </h3>{' '}
                    <p className="description">
                      <Link
                        style={{ color: 'var(--black)' }}
                        to={`/tuyen-dung/${post.slug}`}
                        title={post.title}
                      >
                        {truncateWords(post.short_description, 20)}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="mt-4 text-center">Không có dữ liệu bài viết.</p>
          )}
        </div>
      </div>
      {posts.posts.length > 0 && (
        <Pagination
          onTop={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          setPage={setPageIndex}
          totalPages={posts.totalPages}
          currentPage={posts.currentPage}
        />
      )}
      <div className="redirect">
        <h3>Thành Đồng – Chất lượng cao cho mọi công trình</h3>
        <p>Thành Đồng Group đang chờ bạn. Gia nhập và khám phá ngay!</p>
        <button onClick={handleNavigative}>Các vị trí đang tuyển</button>
      </div>
    </section>
  );
};

export default CulturePost;
